
import React, { useContext, useEffect, useRef, useState } from "react";
import { Colorcontext } from "../../../Component/Colorcontext/ColorContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HttpClient from "../../../utils/HttpClient";
import bannerloginimage from "../../../Images/bannerloginimage.png";
import "../../SearchHome/Style.css"
import SkeletonSignupForm from "../../../View/SearchHome/skeletons/SkeletonSignupForm";
import { useSelector } from 'react-redux'

const BusinessProfileName = ({ onNext, onBack }) => {
    const colordata = useContext(Colorcontext);
    const location = useLocation();
    const navigate = useNavigate();
    const { UserProfileID, subscriptionId } = useSelector((state) => state.app);
    const [formData, setFormData] = useState({
        userLink: "",
        userName: UserProfileID?.userName || "",
        emailId: UserProfileID?.emailId,
    });
    const [userName, setUserName] = useState("")
    const [checkFormError, setCheckFormError] = useState({
        userNameError: false,
    });
    const newLocal = "check-profile-link";
    const [errorMessage, setErrorMessage] = useState("");
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (!UserProfileID) {
            navigate("/");
        }
        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);

    useEffect(() => {
        setCheckFormError({ ...checkFormError, userNameError: true })
    }, [userName])

    const checkProfileName = async (val) => {
        const link = process.env.REACT_APP_APPLICATION_URL + '/Memberinvitation/' + val
        try {
            const res = await HttpClient.requestData("check-link-availability", "POST", { userLink: link, emailId: UserProfileID.emailId });
            if (res?.status) {
                setCheckFormError({ ...checkFormError, userNameError: false })
                setFormData({ ...formData, userLink: link, userName: val, emailId: UserProfileID.emailId })
            }
        } catch (error) {
            console.log("Profile name availability:", error);
        }
    }

    const handleCreate = async (e) => {
        e.preventDefault()
        setErrorMessage("");
        setShowLoader(true);
        try {
            const response = await HttpClient.requestData("update-profile-name", "PUT", formData);
            if (response?.status) {
                onNext();
            } else {
                setErrorMessage(response?.message);
            }
            setShowLoader(false);
        } catch (error) {
            console.log("Non member create:", error);
            setShowLoader(false);
        }
    }

    return (
        <>
            <section className="wizrd-item-section">
                <div className="wizrd-item-container">
                    <div className="Searchloginformmainbg">
                        <div className="Searchloginformmainleft">
                            <div className="Searchloginformmainleftimg">
                                <img src={bannerloginimage} alt="banner" />
                            </div>
                        </div>
                        {showLoader ? (<SkeletonSignupForm />) : (
                            <div className="Searchloginformmainright">
                                <div className="Searchloginformmainrightbg">
                                    <h2 className="_creattusettxpp mb-4">Create your profile name for business or personal</h2>
                                    <p>Share a link and connect customers to grow your audience with a free digital business card.</p>
                                    <div className="mt-4">
                                        <p className="usenametxttpp">Profile name</p>
                                        <input
                                            type="text"
                                            placeholder="Enter desired profile name"
                                            className="neooTextbox"
                                            name="userName"
                                            value={userName}
                                            onChange={(e) => {
                                                const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9_]/g, '');
                                                setUserName(cleanedValue);
                                                checkProfileName(cleanedValue)
                                            }}
                                        />
                                        <p className="p-1">{`${process.env.REACT_APP_APPLICATION_URL}/profile/${userName}`}</p>

                                    </div>

                                    {userName && (
                                        <p className="error-message">
                                            {checkFormError.userNameError ? "Not available ❌" : "Available ✅"}
                                        </p>
                                    )}

                                    {errorMessage && (
                                        <div className="text-danger mb-1">
                                            {errorMessage}
                                        </div>
                                    )}
                                    <button className="btn btn-secondary mr-2" onClick={onBack}>
                                        Back
                                    </button>

                                    <button className="btnnexttdivbtn mt-5"
                                        disabled={checkFormError.userNameError}
                                        onClick={(e) => handleCreate(e)}
                                    >
                                        Create
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default BusinessProfileName;
